module.exports = __webpack_public_path__ + "img/csv.51021b3b.svg";